import { Component } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  selector: 'app-fcsc-fsf-info-modal',
  templateUrl: './fcsc-fsf-info-modal.component.html',
  styleUrls: ['./fcsc-fsf-info-modal.component.scss']
})
export class FcscFsfInfoModalComponent {

  constructor( public activeModal: NgbActiveModal) { }

}
